<template>
  <b-card no-body>
    <b-card-body>      
      <!-- Metabase Dashboard Iframe -->
      <b-row class="mt-2">
        <b-col cols="12">
          <iframe
            :src="iframeUrl"
            frameBorder="0"
            width="100%"
            height="1000"
            allowTransparency
          />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BFormInput, BButton, BFormDatepicker,
} from 'bootstrap-vue'
import {
  exportRekapitulasiHasil,
} from '@/connection-api/master'

// JWT for Metabase embedding
var jwt = require("jsonwebtoken")

// Metabase configuration from environment variables
var METABASE_SITE_URL = process.env.VUE_APP_METABASE_SITE_URL || "https://bi.portal-psikoui.com"
var METABASE_SECRET_KEY = process.env.VUE_APP_METABASE_SECRET_KEY || ""
var METABASE_DASHBOARD_ID = parseInt(process.env.VUE_APP_METABASE_DASHBOARD_ID || "4", 10)

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BFormInput,
    BButton,
    BFormDatepicker,
  },
  data() {
    return {
      filter: {
        periode_dari: '',
        periode_sampai: ''
      },
      count: 0,
      iframeUrl: ''
    }
  },
  props: {
    triggerFilter: {
      default: null,
    },
    dataFilter: {
      default: null,
    },
  },
  created() {
    this.generateMetabaseUrl()
  },
  methods: {
    async download() {
      this.showLoader = true
      const response = await exportRekapitulasiHasil(this.filter)
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'Rekapitulasi-Hasil.xlsx')
      document.body.appendChild(link)
      link.click()
      this.showLoader = false
    },
    generateMetabaseUrl() {
      var payload = { 
        resource: { dashboard: METABASE_DASHBOARD_ID }, 
        params: {}, 
        exp: Math.round(Date.now() / 1000) + (10 * 60) // 10 minute expiration 
      }
      var token = jwt.sign(payload, METABASE_SECRET_KEY)
      
      this.iframeUrl = METABASE_SITE_URL + "/embed/dashboard/" + token + 
        "#bordered=true&titled=true&download=true&theme=transparent"
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
